export class InvalidArgumentException extends Error {
  constructor(msg: string) {
    super(msg);
  }
}
